import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ReenviarDocumentos } from './types';

export const INITIAL_STATE: ReenviarDocumentos = {
	status: 0,
	data: null,
	mensagem: '',
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ReenviarDocumentos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.REENVIAR_DOCUMENTOS_REQUEST: {
				break;
			}

			case Types.REENVIAR_DOCUMENTOS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}

			case Types.REENVIAR_DOCUMENTOS_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				draft.mensagem = action.payload.mensagem;
				break;
			}
			case Types.REENVIAR_DOCUMENTOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.mensagem = INITIAL_STATE.mensagem;
				break;
			}

			default:
		}
		return draft;
	});
}
